export const onError = handler => (next, restart, last) => (operation, context) =>
	next(operation, context).catch(err => handler(err, { next, restart, last, operation, context }));
